import type { SpinPhase } from "./SpinCoordinatorTypes";

/**
 * The spin coordinator's phase for code built before the coordinator — a title's presentation, which the runtime is
 * built around: the runtime publishes every change. "idle" until it does.
 */
export class SpinPhaseStore {
  private phase: SpinPhase = "idle";
  private readonly listeners = new Set<(phase: SpinPhase) => void>();

  public getPhase(): SpinPhase {
    return this.phase;
  }

  public set(phase: SpinPhase): void {
    if (phase === this.phase) return;
    this.phase = phase;
    for (const listener of [...this.listeners]) listener(phase);
  }

  public subscribe(listener: (phase: SpinPhase) => void): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }
}
